import { __assign, __rest } from "tslib";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from "react";
import { NumberTag, Tab, TransparentTab } from "./styles";
export var TAB_OPTIONS = {
    default: Tab,
    transparent: TransparentTab,
};
export var SingleTab = forwardRef(function SingleTab(_a, ref) {
    var icon = _a.icon, counter = _a.counter, isSelected = _a.isSelected, children = _a.children, _b = _a.variant, variant = _b === void 0 ? "default" : _b, props = __rest(_a, ["icon", "counter", "isSelected", "children", "variant"]);
    var TabToRender = TAB_OPTIONS[variant];
    return (_jsxs(TabToRender, __assign({ ref: ref, "$isSelected": isSelected }, props, { children: [icon, children, !isNaN(Number(counter)) && _jsx(NumberTag, { children: counter })] })));
});
//# sourceMappingURL=index.js.map